const decodeBase64 = string => atob(string);
export default decodeBase64;



// WEBPACK FOOTER //
// ./src/lib/helpers/PDFHelpers/decodeBase64.js